import one from '../assets/svg/projects/ones.png'
import two from '../assets/svg/projects/twos.png'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/fours.jpeg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Life Happens',
        projectDesc: 'This web app allows user to have a quick glance of his/her day. The interface displays the weather of the day, add any to-do items to complete, the stock market performance as well as the local news.',
        tags: "HTML, CSS, JavaScript ,Bulma , Third-party APIs",
        code: 'https://github.com/ywkuo227/life-happens',
        demo: 'https://ywkuo227.github.io/life-happens/',
        image: one
    },
    {
        id: 2,
        projectName: 'Family Knowledge Exchange',
        projectDesc: 'An app that links together different individuals and stakeholder interested in supporting families, in their respectful fields.',
        tags: "Express.js, React.js, React-Bootstrap, styled-component,JWT validation, Node.js, MongoDB, Apollo-Server-Express, GraphQL",
        code: 'https://github.com/kelebetengida/family-knowledge-exchange.git',
        demo: 'https://fierce-island-14478.herokuapp.com/',
        image: two
    },{
        id: 4,
        projectName: 'Just Tech News',
        projectDesc: 'Just Tech News is a website where users can post, upvote, and comment on links to news articles. ',
        tags: "Python, Python Flask, SQL, SQLAlchemy, Javascript, Procfile, Handlebar JS, CSS,  Heroku",
        code: 'https://github.com/kelebetengida/python-newsfeed',
        demo: 'https://kelebetsnewsfeed.herokuapp.com/',
        image: four
    },
    // {
    //     id: 3,
    //     projectName: 'Weather App',
    //     projectDesc: 'Weather forecast systems and applications predict weather conditions based on multiple parameters.',
    //     tags: ['Django', 'CSS', 'Material Ui'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: three
    // },
    
    // {
    //     id: 5,
    //     projectName: 'E-Commerce App',
    //     projectDesc: 'A Simple E-commerce application',
    //     tags: ['React Native', 'Firebase'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/